import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Eye } from "lucide-react";
import TableActionLink from "@packages/components/table-action-link";
import { Text } from "@core/index";

const columnHelper = createColumnHelper<any>();

export const useStudentTableColumns = () => {
  const { t } = useTranslation();
  const columns = useMemo(
    () => [
      columnHelper.accessor("name", {
        header: t("students.table.name"),
        cell: (info) => (
          <div className="flex items-center">
            <Text variant="span" size={"base"} weight={"medium"}>
              {info.getValue()}
            </Text>
          </div>
        ),
      }),
      columnHelper.accessor("surname", {
        header: t("students.table.surname"),
        cell: (info) => (
          <div className="flex items-center">
            <Text variant="span" size={"base"} weight={"medium"}>
              {info.getValue()}
            </Text>
          </div>
        ),
      }),
      columnHelper.accessor("email", {
        header: t("students.table.email"),
        cell: (info) => (
          <Text variant="span" size={"sm"} status="secondary">
            {info.getValue()}
          </Text>
        ),
      }),
      columnHelper.accessor("grade", {
        header: t("students.table.grade"),
        cell: (info) => (
          <Text variant="span" size={"sm"} status="secondary">
            {info.getValue() || "N/A"}
          </Text>
        ),
      }),
      columnHelper.accessor("id", {
        header: t("students.table.actions.title"),
        cell: (info) => (
          <div className="flex items-center">
            <TableActionLink
              icon={<Eye size={24} />}
              label={t("students.table.actions.viewStudent")}
              to={`/students/${info.getValue()}`}
            />
          </div>
        ),
      }),
    ],
    [t],
  );

  return columns;
};
